// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const YOUNGJIN_FIELD_ALIASES = {
  hospitalName: ['YJP 거래처명'],
  accountName: ['거래처명'],
  drugCode: ['EDI코드'],
  drugName: ['EDI 품목명', '품목명'],
  quantity: ['수량'],
  unitPrice: ['기준가'],
  prescriptionAmount: ['처방금액'],
  feeRate: ['수수료율(VAT 포함)'],
  settlementAmount: ['수수료 계'],
  note: ['비고'],
  lowAmountFlag: ['처방병원 기준 10만원 미만처'],
};

const REQUIRED_HEADERS = [
  '업체명',
  '처방년도',
  '처방월',
  'YJP 코드',
  'YJP 거래처명',
  '거래처명',
  '주소',
  'HIRA 기준 지역 1',
  'HIRA 기준 지역 2',
  'EDI코드',
  'EDI 품목명',
  '품목명',
  '규격',
  '수량',
  '기준가',
  '처방금액',
  '수수료율',
  '수수료율(VAT 포함)',
  '공급가액',
  'VAT',
  '수수료 계',
  '비고',
  '처방병원 기준 10만원 미만처',
];

function isYoungjinProfile(profile) {
  return REQUIRED_HEADERS.every((header) =>
    profile.headers.some(
      (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
    ),
  );
}

const youngjinPharmTemplate = {
  id: 'youngjin-pharm',
  name: '영진약품 템플릿',
  match(context) {
    return context.headerProfiles.some(isYoungjinProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isYoungjinProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(YOUNGJIN_FIELD_ALIASES),
    );
    const extractedRows = [];
    const detectedPharmaceuticalCompany = '영진약품';

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const drugCode = cleanText(row[columnMap.drugCode]);
      if (!drugCode) {
        return;
      }

      const note = [row[columnMap.note], row[columnMap.lowAmountFlag]]
        .map((value) => cleanText(value))
        .filter(Boolean)
        .join(' / ');

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany,
        hospitalName: row[columnMap.hospitalName],
        accountName: row[columnMap.accountName],
        drugCode,
        drugName: row[columnMap.drugName],
        unitPriceValue: row[columnMap.unitPrice],
        quantityValue: row[columnMap.quantity],
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        feeRateValue: row[columnMap.feeRate],
        settlementAmountValue: row[columnMap.settlementAmount],
        note,
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: detectedPharmaceuticalCompany,
      templateName: this.name,
    };
  },
};

export default youngjinPharmTemplate;
